import { render, staticRenderFns } from "./declined.vue?vue&type=template&id=d60ae2b2&"
import script from "./declined.vue?vue&type=script&lang=js&"
export * from "./declined.vue?vue&type=script&lang=js&"
import style0 from "./declined.vue?vue&type=style&index=0&id=d60ae2b2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports